import Layout from '../layout/default';
import DataTable from '../components/DataTable/DataTable';
import { useEffect, useState, useRef, useContext } from "react";
import { Link, Route, Routes} from 'react-router-dom'
import { Navigate } from "react-router-dom";
import { MediaGroup, Media, MediaText, Image, Icon, CustomDropdownToggle, CustomDropdownMenu, LinkList, LinkListItem, Rating } from "../components";
import { Dropdown } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { AppContext } from '../context/AppContext';
import { useApiClient } from '../ApiService/useApiClient';

const baseURL = "HMCareTask/tasklist/";

export const tableColumns = [
    {
      name: "Job #",
      selector: (row) => row.taskid,
      sortable: true,
      cell: (row) => (
        <MediaGroup>            
            <MediaText>
                <Link to={`/jobsheet/${row.taskid}`} className="title">{row.taskid}</Link>
            </MediaText>
        </MediaGroup>
        ),
    },
    {
        name: "Client",
        selector: (row) => row.clientname,
        sortable: true,
      },
    {
      name: "Date",
      selector: (row) => row.taskdate,
      sortable: true,
    },
    {
      name: "Start Time",
      selector: (row) => row.start_time,
      sortable: true,
    },
    {
      name: "End time",
      selector: (row) => row.end_time,
      sortable: true,
    },
    {
      name: "Hours",
      selector: (row) => row.no_of_hours,
      sortable: true,
    },
    {
      name: "action",
      cell: (row) => (
          <div className="text-end w-100"> 

        <MediaGroup>            
            <MediaText>
                <Link to={`/jobsheet/${row.taskid}`} className="title"><Icon name="eye"></Icon> VIEW</Link>
            </MediaText>
        </MediaGroup>

        {/* <LinkList className="link-list-hover-bg-primary link-list-md">                           
            <LinkListItem to={`/jobsheet/${row.taskid}`}>
                <Icon name="eye"></Icon><span>View</span>
            </LinkListItem>
        </LinkList> */}
        {/* <Dropdown>
            <Dropdown.Toggle size="sm" as={CustomDropdownToggle} className="btn btn-sm btn-icon btn-zoom me-n1">
                <Icon name="more-v"></Icon>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-sm" as={CustomDropdownMenu} align="end">
                <div className="dropdown-content py-1">
                    <LinkList className="link-list-hover-bg-primary link-list-md">
                        <LinkListItem to={`/ecommerce/edit-product/${row.id}`}>
                            <Icon name="edit"></Icon><span>Edit</span>
                        </LinkListItem>                       
                        <LinkListItem to={`/jobsheet/${row.taskid}`}>
                            <Icon name="eye"></Icon><span>View Details</span>
                        </LinkListItem>
                    </LinkList>
                </div>
            </Dropdown.Menu>
        </Dropdown> */}

             {/* <div className="dropdown-content py-1">
                  <LinkList className="link-list-hover-bg-primary link-list-md">                               
                      <LinkListItem to={`/jobsheet/${row.taskid}`} >
                          <Icon name="eye"></Icon><span>View Details</span>
                      </LinkListItem>
                  </LinkList>
              </div>                   */}
          </div>
      ),
      sortable: false,
      hide: "md",
  },
    
];


const Jobsheets = ({restrictedMode}) => {

      const api = useApiClient()
      const { user, SiteConfig } = useContext(AppContext);

  const dataFetchedRef = useRef(false);
    const[data, setdata] = useState(null);  
    const[error, setError] = useState(null); 

    if(!restrictedMode) restrictedMode =false;
  
    useEffect(()=>{

      if (dataFetchedRef.current) return;
      dataFetchedRef.current = true;

            
        let baseURL1 = baseURL;
        if(restrictedMode) baseURL1 = baseURL + SiteConfig.CURRENT_USER_ID
    
          api.get(baseURL1)        
            .then((Response)=>{
                setdata(Response.data);
            }).catch(error => {
                setError(error);     
                //console.log({error})
            });
          }, []);
    
        if (error) 
        {      
          if(error.message.indexOf("status code 401")){
            return <Navigate to="/auths/auth-login" />
          } else
          return "Error: ${error.message}";
        }
    
        //if(!data) return null;
        if(!data) return (
          <Layout title="Clients" content="container"><Spinner animation="border" variant="primary" /></Layout>
          );
     

  return (
    <Layout title="Data Tables" content="container">
      <h2>Job Sheets</h2>
      <DataTable 
        tableClassName="data-table-head-light table-responsive" 
        pointerOnHover={true} 
        data={data} 
        columns={tableColumns} 
        striped={true} 
        highlightOnHover={true} 
        filterFieldName={"clientname"} 
        onRowClicked={(row,event)=>{ 
          return(
          <MediaGroup>            
              <MediaText>
                  <Link to={`/ecommerce/edit-product/${row.id}`} className="title">{row.taskid}</Link>
              </MediaText>
          </MediaGroup>)
        }} 
        pagination 
                    
      />    
  
</Layout>
)
}

export default Jobsheets